import gql from 'graphql-tag';
import { ADMIN_USER_FRAGMENT } from 'data/fragments/user';

export const GET_TOTEAM_MESSAGES_QUERY = gql`
    query GET_TOTEAM_MESSAGES {
        toteamMessages {
            message
            userFullName
        }
    }
`;

export const GET_TOTEAM_USERS_QUERY = gql`
    query GET_TOTEAM_USERS {
        toteamUsers {
            _id
            profile {
                fullname
            }
        }
    }
`;

export const GET_USER_QUERY = gql`
    query GET_USER($userId: ID!) {
        userFromAdmin(userId: $userId) {
            ...AdminUserFragment
        }
    }
    ${ADMIN_USER_FRAGMENT}
`;

export const GET_USERS_QUERY = gql`
    query GET_USERS($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $filters: UsersFilterInput) {
        users(offset: $offset, limit: $limit, sortBy: $sortBy, sortOrder: $sortOrder, filters: $filters) {
            users {
                _id
                createdAt
                lastSeenAt
                username
                source
                lastSite {
                    _id
                    name
                }
                permissions {
                    userGroup
                }
                profile {
                    fullname
                    state
                    organizationId
                    organizationName
                }
                organization {
                    _id
                    name
                }
            }
            hasMore
        }
    }
`;

export const GET_ORGANIZATION_USERS_QUERY = gql`
    query GET_ORGANIZATION_USERS($organizationId: String!) {
        organizationUsers(organizationId: $organizationId) {
            _id
            createdAt
            lastSeenAt
            username
            source
            lastSite {
                _id
                name
            }
            permissions {
                userGroup
                totemId
            }
            profile {
                fullname
                state
            }
        }
    }
`;

export const GET_DELIVERY_PEOPLE_QUERY = gql`
    query GET_DELIVERY_PEOPLE {
        getDeliveryPeople {
            _id
            profile {
                fullname
            }
            username
        }
    }
`;

export const GET_USERS_BY_GROUPS_QUERY = gql`
    query GET_USERS_BY_GROUPS($userGroups: [UserPermission!]!) {
        usersByGroups(userGroups: $userGroups) {
            _id
            username
            profile {
                fullname
            }
        }
    }
`;

export const GET_TEST_SENSEI_GATE_TOKEN_QUERY = gql`
    query GET_TEST_SENSEI_GATE_TOKEN($senseiUserId: ID!, $isStaff: Boolean!) {
        testSenseiGateToken(senseiUserId: $senseiUserId, isStaff: $isStaff)
    }
`;
